import React, { Fragment, useState } from "react";
import { Col, Card, Row } from "reactstrap";
import { H3, H4, H6 } from "../../../../AbstractElements";
import defaultUserImage from "../../../../assets/images/user-profile/default-users.png";
import ProStaticWidgets from "./ProStaticWidgets";

const UserProfileCard = ({ details, personalData }) => {
  const [userImage, setUserImage] = useState("");



  // Parse name
  const firstName = personalData?.first_name || "";
  const formattedFirstName =
    firstName.charAt(0).toUpperCase() + firstName.slice(1);

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setUserImage(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  return (
    <Fragment>
      <Col sm="12" md="12">
        <Card
          className="profile-header bg-size"
          style={{
            padding: "15px",
            borderRadius: "20px",
          }}
        >
          <Row>
            {/* LEFT SIDE (MATCHED EXACT DOM FROM MASTERPROFILE) */}
            <Col xl="5" sm="12" lg="5" md="12">
              <div className="profile-img-wrrap"></div>

              <div className="userpro-box">
                <div className="img-wrapper">
                  <div className="master-avatar">
                    <img
                      className="step1 "
                      alt="default-image"
                      src={userImage || defaultUserImage}
                      data-intro="This is Profile image"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </div>

                  <div className="master-icon-wrapper">
                    <label htmlFor="fileInput" style={{ paddingTop: "7px" }}>
                      <i
                        className="icofont icofont-plus-circle step2"
                        data-intro="Change Profile image here"
                      ></i>
                    </label>
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={handleFileSelect}
                    />
                  </div>
                </div>

                <div className="user-designation">
                  <div className="title" style={{ paddingBottom: "10px" }}>
                    <H4>
                      {formattedFirstName} {personalData?.last_name}
                    </H4>

                    <H3>{personalData?.email}</H3>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "5px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#fff",
                        backgroundColor:
                          personalData?.status === "active"
                            ? "green"
                            : "orange",
                        marginTop: "8px",
                      }}
                    >
                      {personalData?.status}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            {/* RIGHT SIDE */}
            <Col
              xs="12"
              sm="12"
              lg="7"
              className="personalBusinessDetails"
              style={{ overflow: "visible" }}
            >
              <Row className="profileCards">
                <ProStaticWidgets details={details} />
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Fragment>
  );
};

export default UserProfileCard;
